import type { App } from 'vue'
import type { Router } from 'vue-router'
import * as Sentry from '@sentry/vue'

let initialized = false

export function initSentry(app: App, router: Router): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
  if (!dsn) {
    return
  }

  Sentry.init({
    app,
    dsn,
    environment: (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ?? 'production',
    release: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: true,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
    sendDefaultPii: false,
  })

  initialized = true
}

export function setSentryUserId(id: string | number | null | undefined): void {
  if (!initialized) return
  if (id === null || id === undefined || id === '') {
    Sentry.setUser(null)
    return
  }
  Sentry.setUser({ id: String(id) })
}

export function clearSentryUser(): void {
  if (!initialized) return
  Sentry.setUser(null)
}

export function isSentryInitialized(): boolean {
  return initialized
}
